import { WebhooksDrawerForm } from '../webhooks-drawer-form'
import { useEffect, useState } from 'react'
import type { WebhookDrawerProps } from '../../../../typings/pages'
import { useCreateWebhook, useEditWebhook } from './webhook-drawer.hooks'
import { queryClient } from '@yuno/dashboard-api-mfe'
import { apiStatus } from '../../../../typings/pages/utils'
import { useAccount } from '@yuno/dashboard-container-mfe'
import { useTranslation } from 'react-i18next'

const WebhookCreate = (props: WebhookDrawerProps) => {
  const { open, onClose, webhooksList } = props
  const [hasSuccess, setSuccess] = useState(false)
  const [hasError, setError] = useState<{
    isError: boolean
    isGeneric: boolean
  }>({ isError: false, isGeneric: true })

  const {
    isLoading,
    params,
    handleSubmit,
    handleSuccess,
    isLoadingCreate,
    createStatus,
    dataError,
    name,
  } = useCreateWebhook({ onClose, setError })
  const account = useAccount()
  const { t } = useTranslation()

  useEffect(() => {
    if (createStatus === apiStatus.success) {
      queryClient.resetQueries('webhooks', { exact: true })
      setSuccess(true)
    }

    if (createStatus === apiStatus.error) {
      queryClient.resetQueries('webhooks', { exact: true })
      if (dataError?.message?.includes(account?.code)) {
        setError({ isGeneric: false, isError: true })
      } else {
        setError({ isGeneric: true, isError: true })
      }
    }
  }, [createStatus])

  if (isLoading) return null

  return (
    <WebhooksDrawerForm
      open={open}
      mode="CREATE"
      title={t('addWebhook')}
      fields={params}
      onClose={onClose}
      handleSubmit={handleSubmit}
      onSecondaryAction={onClose}
      hasSuccess={hasSuccess}
      hasError={hasError}
      onPrimaryAction={handleSuccess}
      primaryLabel={hasSuccess ? t('done') : null}
      isLoading={isLoadingCreate}
      webhooksList={webhooksList}
      nameWebhook={name}
    />
  )
}

const WebhookEdit = (props: WebhookDrawerProps) => {
  const { open, onSuccess, payload, onClose, webhooksList, onError } = props
  const { t } = useTranslation()

  const { id: code } = payload

  const { isLoading, params, handleSubmit, isLoadingUpdate } = useEditWebhook({
    onSuccess,
    payload,
    onError,
  })

  if (isLoading) return null

  return (
    <WebhooksDrawerForm
      open={open}
      mode="EDIT"
      title={`${t('edit')}${payload?.name}`}
      code={code}
      fields={params}
      onClose={onClose}
      handleSubmit={handleSubmit}
      onPrimaryAction={null}
      onSecondaryAction={onClose}
      primaryLabel={t('saveChanges')}
      isLoading={isLoadingUpdate}
      webhooksList={webhooksList}
    />
  )
}

const WebhookDrawer = (props: WebhookDrawerProps) => {
  if (props?.payload) {
    return <WebhookEdit {...props} />
  }

  return <WebhookCreate {...props} />
}

export default WebhookDrawer
